export default __webpack_public_path__ + "static/media/IE.c5b1983b.ico";